import { render } from "./couponList.vue?vue&type=template&id=e28e48e0&scoped=true"
import script from "./couponList.vue?vue&type=script&lang=js"
export * from "./couponList.vue?vue&type=script&lang=js"

import "./couponList.vue?vue&type=style&index=0&id=e28e48e0&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28e48e0"]])

export default __exports__